package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DeleteW500Rounded: ImageVector
    get() {
        if (_deleteW500Rounded != null) {
            return _deleteW500Rounded!!
        }
        _deleteW500Rounded = Builder(name = "DeleteW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(277.37f, 848.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-514.5f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                lineTo(354.5f, 151.63f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(159.52f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                horizontalLineToRelative(168.61f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                verticalLineToRelative(514.5f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(277.37f, 848.13f)
                close()
                moveTo(682.63f, 242.63f)
                lineTo(277.37f, 242.63f)
                verticalLineToRelative(514.5f)
                horizontalLineToRelative(405.26f)
                verticalLineToRelative(-514.5f)
                close()
                moveTo(428.86f, 667.42f)
                quadToRelative(12.34f, -12.33f, 12.34f, -30.29f)
                verticalLineToRelative(-274.74f)
                quadToRelative(0.0f, -17.96f, -12.34f, -30.29f)
                quadToRelative(-12.34f, -12.34f, -30.29f, -12.34f)
                quadToRelative(-17.96f, 0.0f, -30.42f, 12.34f)
                quadToRelative(-12.45f, 12.33f, -12.45f, 30.29f)
                verticalLineToRelative(274.74f)
                quadToRelative(0.0f, 17.96f, 12.45f, 30.29f)
                quadToRelative(12.46f, 12.34f, 30.42f, 12.34f)
                quadToRelative(17.95f, 0.0f, 30.29f, -12.34f)
                close()
                moveTo(591.97f, 667.42f)
                quadToRelative(12.33f, -12.33f, 12.33f, -30.29f)
                verticalLineToRelative(-274.74f)
                quadToRelative(0.0f, -17.96f, -12.33f, -30.29f)
                quadToRelative(-12.34f, -12.34f, -30.3f, -12.34f)
                quadToRelative(-17.95f, 0.0f, -30.41f, 12.34f)
                quadToRelative(-12.46f, 12.33f, -12.46f, 30.29f)
                verticalLineToRelative(274.74f)
                quadToRelative(0.0f, 17.96f, 12.46f, 30.29f)
                quadToRelative(12.46f, 12.34f, 30.41f, 12.34f)
                quadToRelative(17.96f, 0.0f, 30.3f, -12.34f)
                close()
                moveTo(277.37f, 242.63f)
                verticalLineToRelative(514.5f)
                verticalLineToRelative(-514.5f)
                close()
            }
        }
        .build()
        return _deleteW500Rounded!!
    }

private var _deleteW500Rounded: ImageVector? = null
